import { Box, Button, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, Stack, Typography } from '@mui/material';
import * as React from 'react';
import AddStoreModal from './AddStoreModal';
import { useState } from 'react';
import { Store } from '../Services/Store/StoreApi';
import { useStores } from '../Services/Store/StoreHooks';
import AddIcon from '@mui/icons-material/Add';
import { getErrorMessage } from '../../Common/Utils/ErrorUtils';

interface StoreSelectProps {
    onSelect: (selected: Store) => void;
    selected: Store | undefined;
}

export default function StoreSelect({ onSelect, selected }: StoreSelectProps) {
    const { data: stores, isError, error } = useStores();
    const [openStoreModal, setOpenStoreModal] = useState(false);

    const handleSelect = (event: SelectChangeEvent) => {
        const selectedId = event.target.value as string;
        onSelect(stores!.find(o => o.id === selectedId)!);
    };

    const getMenuItem = (store: Store) => {
        return (
            <MenuItem value={store.id} key={store.id}>{store.name}</MenuItem>
        );
    };

    const handleNewStoreSelect = (store: Store) => store && onSelect(store);

    const handleModalToggle = () => setOpenStoreModal(!openStoreModal);

    return (
        <Box>
            {stores ? (
                <Stack direction="row">
                    <FormControl fullWidth>
                        <InputLabel id="store-select-label">Select Store</InputLabel>
                        <Select
                            labelId="store-select-label"
                            label="Select Store"
                            onChange={handleSelect}
                            value={selected?.id ?? ""}
                        >
                            {stores.sort().map(getMenuItem)}
                        </Select>
                    </FormControl>
                    <Button startIcon={<AddIcon />} onClick={handleModalToggle}>Add</Button>
                </Stack>
            ) : isError ? (
                <Typography>{getErrorMessage(error)}</Typography>
            ) : (
                <Typography>Loading</Typography>
            )}
            <AddStoreModal open={openStoreModal} onClose={handleModalToggle} onSelect={handleNewStoreSelect} />
        </Box>
    );
}
